// extracted by mini-css-extract-plugin
export default {"indicatorGroupWrapper":"IndicatorGroup_indicatorGroupWrapper__tg0T5","heading":"IndicatorGroup_heading__opL-7","mainBox":"IndicatorGroup_mainBox__9zAdL"};